module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS"), _c('br'), _vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Copyright © 1998 by New York University"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Seriatim : the Supreme Court before John Marshall / edited by Scott")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Douglas Gerber.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("p.  cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Includes index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 0-8147-3114-7 (cloth : alk paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1. United States. Supreme Court—History. 2. Judges—United")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("States—Biography. 3. Judicial review—United States—History.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("4. Law and politics—History. I. Gerber, Scott Douglas, 1961-")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("KF8742.S47 1998")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("347.73’26—dc21              98-9056"), _c('br'), _vm._v("                                                CIP")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0